<template>

	<v-btn color="red" text icon large @click="endCall">
		<v-icon large>mdi-phone-hangup</v-icon>
	</v-btn>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "EndCallButton", 
		props: {
			room: {},
			twilioObject: {}	
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user
			})
		},
		methods: {
			endCall(){
				var room = this.twilioObject;
				Array.from(room.localParticipant.tracks.values()).forEach( track => {
					track.track.stop();
					room.localParticipant.unpublishTrack(track.track)
				})
				room.disconnect();
				this.$store.dispatch("updateDoc", {
					doc: `videoRooms/${this.room}/participants/${this.user.uid}`, 
					action: "update", 
					data: {status: "disconnected"} 
				})
			}
		}
		// created(){
			
		// }

	}
// </script>"